import { createApp } from "vue";
import ChatMain from '@/views/ChatMain.vue'
import router from "@/routes/routerIndex";
import "@/assets/css/font.css";
import "@/assets/css/main.css";
import "@/styles/sass/style.scss";

createApp(ChatMain)
  .use(router)
  .mount("#isusys-chatbot-wrapper");
